(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ue-pro-feature-card-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ue-pro-feature-grid-carousel')) {
    customElements.define(
      'ue-pro-feature-grid-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-ue-pro-feature-track]');
          this.cards = Array.from(this.querySelectorAll('.ue-pro-feature-grid__card'));
          this.dots = Array.from(this.querySelectorAll('[data-ue-pro-feature-dot]'));
          this.status = this.querySelector('[data-ue-pro-feature-status]');
          this.currentIndex = 0;
          this.scrollFrame = null;

          if (!this.track || this.cards.length < 2) return;

          this.handleScroll = () => {
            if (this.scrollFrame) return;
            this.scrollFrame = requestAnimationFrame(() => {
              this.scrollFrame = null;
              this.syncCurrentCard();
            });
          };

          this.handleKeydown = (event) => {
            if (!window.matchMedia('(max-width: 749px)').matches) return;
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

            event.preventDefault();
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            this.scrollToCard(this.currentIndex + direction);
          };

          this.handleBlockSelect = (event) => {
            const card = event.target.closest('.ue-pro-feature-grid__card');
            const index = this.cards.indexOf(card);
            if (index >= 0) this.scrollToCard(index, false);
          };

          this.track.addEventListener('scroll', this.handleScroll, { passive: true });
          this.track.addEventListener('keydown', this.handleKeydown);
          this.addEventListener('shopify:block:select', this.handleBlockSelect);

          this.syncCurrentCard(false);
        }

        disconnectedCallback() {
          this.track?.removeEventListener('scroll', this.handleScroll);
          this.track?.removeEventListener('keydown', this.handleKeydown);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        }

        syncCurrentCard(announce = true) {
          const trackLeft = this.track.getBoundingClientRect().left;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          this.cards.forEach((card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          if (closestIndex === this.currentIndex && announce) return;
          this.setCurrentCard(closestIndex, announce);
        }

        setCurrentCard(index, announce = true) {
          this.currentIndex = index;
          this.dots.forEach((dot, index) => {
            if (index === this.currentIndex) {
              dot.dataset.active = 'true';
            } else {
              delete dot.dataset.active;
            }
          });

          if (announce && this.status) {
            this.status.textContent = `Card ${this.currentIndex + 1} of ${this.cards.length}`;
          }
        }

        scrollToCard(index, announce = true) {
          const nextIndex = Math.max(0, Math.min(index, this.cards.length - 1));
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const left = this.cards[nextIndex].offsetLeft - this.track.offsetLeft;
          this.track.scrollTo({ left, behavior: reducedMotion ? 'auto' : 'smooth' });
          this.setCurrentCard(nextIndex, announce);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ue-pro-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ue-pro-hero-slider')) {
    customElements.define(
      'ue-pro-hero-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.events?.abort();
          this.resizeObserver?.disconnect();
          this.finishTransition();
          this.events = new AbortController();
          const eventOptions = { signal: this.events.signal };
          this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
          this.status = this.querySelector('[data-slider-status]');
          this.currentIndex = 0;
          this.initialized = false;
          this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.scheduleMeasure = () => {
            cancelAnimationFrame(this.resizeFrame);
            this.resizeFrame = requestAnimationFrame(() => this.setViewportHeight());
          };
          this.handleViewportResize = () => {
            this.finishTransition();
            this.scheduleMeasure();
          };

          window.addEventListener('resize', this.handleViewportResize, eventOptions);
          document.fonts?.addEventListener('loadingdone', this.scheduleMeasure, eventOptions);
          this.motionPreference.addEventListener('change', () => this.finishTransition(), eventOptions);
          this.resizeObserver = new ResizeObserver(this.scheduleMeasure);
          this.querySelectorAll('.ue-pro-hero-slider__intro, .ue-pro-hero-slider__testimonial').forEach((element) => {
            this.resizeObserver.observe(element);
          });
          this.slides.forEach((slide) => {
            for (const axis of ['x', 'y']) {
              const value = Number(slide.getAttribute(`data-ue-pro-mobile-focus-${axis}`));
              const position = Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : 50;
              slide.style.setProperty(`--ue-pro-hero-slider-mobile-focus-${axis}`, `${position}%`);
            }
            const zoom = Number(slide.getAttribute('data-ue-pro-mobile-zoom'));
            slide.style.setProperty('--ue-pro-hero-slider-mobile-zoom', String(Number.isFinite(zoom) ? Math.min(150, Math.max(100, zoom)) / 100 : 1));
          });

          if (this.slides.length === 0) {
            requestAnimationFrame(() => {
              this.dataset.ready = 'true';
            });
            return;
          }

          this.querySelector('[data-slider-previous]')?.addEventListener('click', () => this.show(this.currentIndex - 1), eventOptions);
          this.querySelector('[data-slider-next]')?.addEventListener('click', () => this.show(this.currentIndex + 1), eventOptions);

          const carousel = this.querySelector('.ue-pro-hero-slider__carousel');
          carousel.addEventListener('pointerdown', (event) => {
            if (!event.isPrimary || event.button !== 0 || event.target.closest('a, button, input, textarea, select')) return;
            if (event.pointerType === 'mouse' && !event.target.closest('.ue-pro-hero-slider__media, .ue-pro-hero-slider__foreground')) return;
            this.swipeStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
          }, eventOptions);
          carousel.addEventListener('dragstart', (event) => event.preventDefault(), eventOptions);
          window.addEventListener('pointerup', (event) => {
            const start = this.swipeStart;
            this.swipeStart = null;
            if (!start || start.id !== event.pointerId) return;
            const dx = event.clientX - start.x;
            const dy = event.clientY - start.y;
            if (Math.abs(dx) >= Math.max(40, carousel.clientWidth * 0.08) && Math.abs(dx) > Math.abs(dy) * 1.25) {
              this.show(this.currentIndex + (dx < 0 ? 1 : -1));
            }
          }, eventOptions);
          window.addEventListener('pointercancel', () => { this.swipeStart = null; }, eventOptions);

          this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.show(index), eventOptions);
            dot.addEventListener('keydown', (event) => this.handleDotKeydown(event, index), eventOptions);
          });

          this.addEventListener('shopify:block:select', (event) => {
            const selectedSlide = event.target.closest('[data-slider-slide]');
            const selectedIndex = this.slides.indexOf(selectedSlide);
            if (selectedIndex >= 0) this.show(selectedIndex, false);
          }, eventOptions);

          this.show(0, false);
          requestAnimationFrame(() => {
            this.dataset.ready = 'true';
          });
        }

        disconnectedCallback() {
          this.events?.abort();
          this.resizeObserver?.disconnect();
          cancelAnimationFrame(this.resizeFrame);
          this.swipeStart = null;
          this.finishTransition();
        }

        setViewportHeight() {
          this.fitHeading();
          if (window.matchMedia('(max-width: 749px)').matches) {
            this.style.removeProperty('--ue-pro-hero-slider-viewport-height');
            const slide = this.slides[this.currentIndex];
            if (!slide) return;

            // Keep the header allowance stable when browser chrome resizes during scroll.
            const sectionTop = Math.max(0, this.getBoundingClientRect().top + window.scrollY);
            const introHeight = this.querySelector('.ue-pro-hero-slider__intro').getBoundingClientRect().height;
            const quoteHeight = slide.querySelector('.ue-pro-hero-slider__testimonial').getBoundingClientRect().height;
            const remainingHeight = window.innerHeight - sectionTop - introHeight - quoteHeight;
            const minimumHeight = parseFloat(getComputedStyle(this).fontSize) * 8;
            // Long copy / short screens can scroll; never hide text or pagination to force a fit.
            this.style.setProperty('--ue-pro-hero-slider-mobile-media-height', `${Math.max(minimumHeight, remainingHeight)}px`);
            this.positionControls();
            return;
          }

          this.style.removeProperty('--ue-pro-hero-slider-mobile-media-height');
          const sectionTop = Math.max(0, this.getBoundingClientRect().top + window.scrollY);
          const intro = this.querySelector('.ue-pro-hero-slider__intro');
          const introStyle = getComputedStyle(intro);
          const introHeight = this.querySelector('.ue-pro-hero-slider__intro-inner').getBoundingClientRect().height
            + parseFloat(introStyle.paddingTop) + parseFloat(introStyle.paddingBottom);
          const quoteHeight = this.slides[this.currentIndex]?.querySelector('.ue-pro-hero-slider__testimonial').getBoundingClientRect().height || 0;
          const availableHeight = Math.max(introHeight, quoteHeight + parseFloat(introStyle.fontSize) * 8, window.innerHeight - sectionTop);
          this.style.setProperty('--ue-pro-hero-slider-viewport-height', `${availableHeight}px`);
          this.positionControls();
        }

        fitHeading() {
          const heading = this.querySelector('.ue-pro-hero-slider__heading-text');
          if (!heading) return;
          heading.style.setProperty('--ue-pro-hero-heading-fit', '1');
          const style = getComputedStyle(heading);
          const baseSize = parseFloat(style.fontSize);
          const baseLineHeight = parseFloat(style.lineHeight);
          const targetLines = Math.max(3, heading.querySelectorAll('br').length + 1);
          if (heading.getBoundingClientRect().height <= baseLineHeight * targetLines + 1) return;

          // Fit only when needed, preserving a readable floor and intentional line breaks.
          const bodySize = parseFloat(getComputedStyle(this).fontSize);
          let low = Math.min(1, Math.max(0.55, bodySize * 1.5 / baseSize));
          let high = 1;
          for (let step = 0; step < 8; step += 1) {
            const scale = (low + high) / 2;
            heading.style.setProperty('--ue-pro-hero-heading-fit', String(scale));
            if (heading.getBoundingClientRect().height <= baseLineHeight * scale * targetLines + 1) {
              low = scale;
            } else {
              high = scale;
            }
          }
          heading.style.setProperty('--ue-pro-hero-heading-fit', String(low));
        }

        positionControls() {
          if (!this.querySelector('[data-slider-controls]')) return;
          const copy = this.slides[this.currentIndex]?.querySelector('.ue-pro-hero-slider__testimonial-copy');
          if (!copy) return;
          const carousel = this.querySelector('.ue-pro-hero-slider__carousel');
          const mobile = window.matchMedia('(max-width: 749px)').matches;
          const gap = parseFloat(getComputedStyle(this).fontSize) * (mobile ? 0.25 : 1);
          const top = copy.getBoundingClientRect().bottom - carousel.getBoundingClientRect().top + gap;
          this.style.setProperty('--ue-pro-hero-controls-top', `${top}px`);
        }

        finishTransition() {
          this.transitionId = (this.transitionId || 0) + 1;
          this.animations?.forEach((animation) => animation.cancel());
          this.animations = [];
          this.querySelectorAll('[data-ue-pro-leaving]').forEach((slide) => {
            slide.hidden = true;
            slide.removeAttribute('data-ue-pro-leaving');
            slide.style.removeProperty('--ue-pro-hero-transition-quote-height');
          });
        }

        show(nextIndex, announce = true) {
          const total = this.slides.length;
          if (!total) return;
          this.finishTransition();
          const previousIndex = this.currentIndex;
          const previous = this.slides[previousIndex];
          const direction = nextIndex < previousIndex ? -1 : 1;
          this.currentIndex = (nextIndex + total) % total;
          const incoming = this.slides[this.currentIndex];
          const animate = this.initialized && announce && previous !== incoming && !this.motionPreference.matches;

          this.slides.forEach((slide, index) => {
            const isCurrent = index === this.currentIndex;
            const isLeaving = animate && slide === previous;
            slide.hidden = !isCurrent && !isLeaving;
            slide.inert = !isCurrent;
            slide.setAttribute('aria-hidden', String(!isCurrent));
            slide.removeAttribute('data-ue-pro-initial-slide');
            if (isLeaving) slide.setAttribute('data-ue-pro-leaving', '');
          });

          if (!this.initialized) incoming.setAttribute('data-ue-pro-initial-slide', '');

          this.dots.forEach((dot, index) => {
            if (index === this.currentIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          if (announce && this.status) {
            this.status.textContent = `Slide ${this.currentIndex + 1} of ${total}`;
          }
          this.setViewportHeight();
          this.initialized = true;

          if (animate) {
            previous.style.setProperty('--ue-pro-hero-transition-quote-height', `${incoming.querySelector('.ue-pro-hero-slider__testimonial').getBoundingClientRect().height}px`);
            const options = { duration: 500, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' };
            const run = (element, frames, timing = options) => {
              if (element) this.animations.push(element.animate(frames, timing));
            };
            run(previous.querySelector('.ue-pro-hero-slider__media'), [
              { transform: 'translateX(0)' }, { transform: `translateX(${-100 * direction}%)` }
            ]);
            run(incoming.querySelector('.ue-pro-hero-slider__media'), [
              { transform: `translateX(${100 * direction}%)` }, { transform: 'translateX(0)' }
            ]);
            run(previous.querySelector('.ue-pro-hero-slider__foreground-image'), [{ opacity: 1 }, { opacity: 0 }], { ...options, duration: 250 });
            run(incoming.querySelector('.ue-pro-hero-slider__foreground-image'), [{ opacity: 0, offset: 0 }, { opacity: 0, offset: 0.25 }, { opacity: 1, offset: 1 }]);
            const transitionId = this.transitionId;
            Promise.all(this.animations.map((animation) => animation.finished)).then(() => {
              if (this.transitionId === transitionId) this.finishTransition();
            }).catch(() => {});
          }
        }

        handleDotKeydown(event, index) {
          let nextIndex = null;
          if (event.key === 'ArrowRight') nextIndex = index + 1;
          if (event.key === 'ArrowLeft') nextIndex = index - 1;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.dots.length - 1;
          if (nextIndex === null) return;

          event.preventDefault();
          this.show(nextIndex);
          nextIndex = (nextIndex + this.dots.length) % this.dots.length;
          this.dots[nextIndex].focus({ preventScroll: true });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ue-pro-product-lineup-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ue-pro-product-lineup-reveal')) {
    customElements.define(
      'ue-pro-product-lineup-reveal',
      class extends HTMLElement {
        connectedCallback() {
          this.cards = Array.from(this.querySelectorAll('.ue-pro-product-lineup__card'));
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (!this.cards.length || reducedMotion || !('IntersectionObserver' in window)) return;

          this.classList.add('is-reveal-ready');
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                this.revealCard(entry.target);
              });
            },
            { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
          );

          this.cards.forEach((card) => this.observer.observe(card));

          this.handleBlockSelect = (event) => {
            const card = event.target.closest('.ue-pro-product-lineup__card');
            if (card) this.revealCard(card);
          };
          this.addEventListener('shopify:block:select', this.handleBlockSelect);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          if (this.handleBlockSelect) {
            this.removeEventListener('shopify:block:select', this.handleBlockSelect);
          }
        }

        revealCard(card) {
          card.classList.add('is-visible');
          this.observer?.unobserve(card);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
